// src/utils/helpers.js

export const preloadImage = (url) => {
    (new Image()).src = url;
};

export const getTVStatus = (status) => {
    switch (status) {
        case 0: return "En emisión";
        case 1: return "Finalizado";
        case 2: return "Hiatus";
        default: return "Otro...";
    }
};

export const getVideoType = (id, abbr) => {
    switch (id) {
        case 0: return abbr ? "Ori" : "Original";
        case 1: return abbr ? "Sub" : "Subtitulado";
        case 2: return abbr ? "Dob" : "Doblado";
        case 3: return abbr ? "S&D" : "Sub/Dob";
        case 95: return abbr ? "N/A" : "Irrecuperable";
        case 99: return abbr ? "N/A" : "No disponible";
        default: return "";
    }
};

export const getLanguageName = (code) => {
    if (!code) return "";
    code = code.toLowerCase();
    switch (code) {
        case "es": return "Español";
        case "es-es": return "Español (España)";
        case "es-419":
        case "es-la": return "Español (Latinoamérica)";
        case "en": return "Inglés";
        case "en-us": return "Inglés (Estados Unidos)";
        case "pt": return "Portugués";
        case "pt-br": return "Portugués (Brasil)";
        case "pt-pt": return "Portugués europeo";
        case "ko": return "Coreano";
        case "ja": return "Japonés";
        case "zh": return "Chino";
        case "eo": return "Esperanto";
        default: return code;
    }
};

export const goToLink = (link, blank) => {
    if (blank) {
        window.open(link, '_blank'); // Añadí '_blank' para asegurar que abra en pestaña nueva
    } else {
        window.location = link;
    }
};

export const getImageSource = (imagesObject, type, size, fallbackImage = null) => {
    let finalImage = fallbackImage;
    if (imagesObject && type in imagesObject) {
        imagesObject[type].forEach(el => {
            if (el.name === size) { finalImage = el.source; }
        });
    }
    return finalImage;
};